import {CALL_OUTCOMES,compareCallTimestamps} from '@bcio-voice/contracts';
import {emptyHistoryFilter,type HistoryFilter} from './historyQuery.ts';

const enums={direction:['inbound','outbound','internal'],state:['created','ringing','active','held','dropping','ended','failed'],outcome:CALL_OUTCOMES,outcome_group:['other','eligible','unanswered','not_connected'],duration:['talk','hold','queue'],person_scope:['activity','handled']} as const;
const keys=['direction','state','outcome','from','to','user_id','number_id','team_id','phone_number','final_only','outcome_group','duration','person_scope'] as const;
const uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function historySearch(filter:HistoryFilter,view:'list'|'log'='list'):URLSearchParams{
 const search=new URLSearchParams();
 if(view==='log')search.set('tab','log');else if(filter.outcome==='missed'&&filter.direction==='inbound')search.set('tab','missed');else if(filter.outcome_group==='not_connected'&&filter.direction==='outbound')search.set('tab','not_connected');
 for(const key of keys){const value=filter[key];if(value!==undefined&&value!==''&&value!==false)search.set(key,String(value));}
 return search;
}
export function historyHref(filter:Partial<HistoryFilter>={},view:'list'|'log'='log'):string{
 const search=historySearch({...emptyHistoryFilter(),...filter},view).toString();return '/inbox/calls'+(search?'?'+search:'');
}
export function historyDetailHref(id:string,search:URLSearchParams):string{
 const text=search.toString();return '/inbox/calls/'+encodeURIComponent(id)+(text?'?'+text:'');
}
export function parseHistorySearch(search:URLSearchParams):{filter:HistoryFilter;view:'list'|'log';error:string|null}{
 const filter:HistoryFilter=emptyHistoryFilter();let error:string|null=null;
 if(search.get('tab')==='missed'){filter.direction='inbound';filter.outcome='missed';}
 if(search.get('tab')==='not_connected'){filter.direction='outbound';filter.outcome_group='not_connected';}
 for(const key of keys){
  const value=search.get(key);if(!value)continue;
  const valid=key in enums?(enums[key as keyof typeof enums] as readonly string[]).includes(value)
   :key==='final_only'?value==='true'||value==='false'
   :key==='from'||key==='to'?/^\d{4}-\d{2}-\d{2}T/.test(value)&&Number.isFinite(Date.parse(value))
   :key==='phone_number'?/^\+[1-9][0-9]{7,14}$/.test(value):uuid.test(value);
  if(!valid||search.getAll(key).length!==1){error='This call-log filter is invalid. Clear the filters to start again.';continue;}
  Object.assign(filter,{[key]:key==='final_only'?value==='true':value});
 }
 if(filter.from&&filter.to&&compareCallTimestamps(filter.from,filter.to)>=0)error='The end of the date range must be after its start.';
 if(filter.person_scope&&!filter.user_id)error='Choose a person for this activity filter.';
 return {filter,view:search.get('tab')==='log'?'log':'list',error};
}
export function historyFilterKey(filter:HistoryFilter):string{return historySearch(filter,'log').toString();}
/** Browser-local controls display the exact ISO bounds without changing the analytics time window. */
export function localDateInput(iso?:string):string{
 if(!iso)return '';const d=new Date(iso);if(!Number.isFinite(d.getTime()))return '';
 const p=(n:number)=>String(n).padStart(2,'0');return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
export const dateInputIso=(value:string):string|undefined=>value&&Number.isFinite(new Date(value).getTime())?new Date(value).toISOString():undefined;

/** Direction is explicit: an outbound non-connection is never presented as an incoming missed call. */
export function unansweredScope(direction:string):string{
 return direction==='inbound'?'Missed incoming calls. ':direction==='outbound'?'Outbound calls that did not connect. ':'Unanswered calls across directions. ';
}
